import {
    CreatePlayerRequest,
    CreatePlayerResponse,
    UpdatePlayerNameRequest,
    UpdatePlayerNameResponse,
} from '../models/player';
import { storePlayerToken } from './player-identity-service';
import { getAuthHeaders } from './auth-headers';

class PlayerService {
    public async createPlayer(name: string) {
        try {
            const request: CreatePlayerRequest = {
                name,
            };
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/players`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request),
            });
            if (!response.ok) {
                throw new Error(`Failed to create player: ${response.status} ${response.statusText}`);
            }
            const body = (await response.json()) as CreatePlayerResponse;
            storePlayerToken(body.id, body.userToken);
            return {
                body,
                status: response.status,
            };
        } catch (error) {
            console.error('Error creating player:', error);
            throw error;
        }
    }

    public async updatePlayerName(id: string, name: string) {
        const request: UpdatePlayerNameRequest = { name };
        const authHeaders = await getAuthHeaders(id);
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/players/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                ...authHeaders,
            },
            body: JSON.stringify(request),
        });
        if (!response.ok) {
            throw new Error(`Failed to update player name: ${response.status} ${response.statusText}`);
        }
        return (await response.json()) as UpdatePlayerNameResponse;
    }

    public async getFavorites(playerId: string) {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/players/${playerId}/favorites`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch favorites: ${response.status} ${response.statusText}`);
        }
        return {
            body: (await response.json()) as { courseIds: string[] },
            status: response.status,
        };
    }
}

export const playerService = new PlayerService();
